// extracted by mini-css-extract-plugin
export default {"popup_wrap":"contractError_popup_wrap__FJQ1X","popup_message":"contractError_popup_message__KEyDQ","popup_message_button":"contractError_popup_message_button__LGZ94"};